import React from 'react';
import PropTypes from 'prop-types';
import ModelListItem from './ModelListItem';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    list: {
        listStyleType: 'none',
        margin: theme.spacing(1),
        paddingInlineStart: 0
    }
}));

const ModelList = ({ models, onSelect, selectedItem, ...others }) => {
    const classes = useStyles();

    const items = models.map(m => {
        return (
            <ModelListItem
                key={m.id}
                model={m}
                onSelect={() => { onSelect && onSelect(m); }}
                selected={m.id === selectedItem}
            />
        )
    });

    return (
        <ul className={classes.list} {...others}>
            {items}
        </ul>
    )
}

ModelList.propTypes = {
    models: PropTypes.array,
    onSelect: PropTypes.func,
    selectedItem: PropTypes.string
}

export default ModelList;
